import api from './api';

export default {
  listByParent(parentId) {
    return api
      .get(`/clients/${parentId}/minors`, {
        params: { functionCode: 'CLIENT_MINOR_VIEW' },
      })
      .then((r) => r.data);
  },

  listAll() {
    return api
      .get('/client-minors', {
        params: { functionCode: 'CLIENT_MINOR_VIEW' },
      })
      .then((r) => r.data);
  },

  get(id) {
    return api
      .get(`/client-minors/${id}`, {
        params: { functionCode: 'CLIENT_MINOR_VIEW' },
      })
      .then((r) => r.data);
  },

  create(parentId, data) {
    return api
      .post(`/clients/${parentId}/minors`, {
        ...data,
        functionCode: 'CLIENT_MINOR_CREATE',
      })
      .then((r) => r.data);
  },

  update(id, data) {
    return api
      .put(`/client-minors/${id}`, {
        ...data,
        functionCode: 'CLIENT_MINOR_UPDATE',
      })
      .then((r) => r.data);
  },

  activate(id) {
    return api
      .patch(`/client-minors/${id}/activate`, {
        functionCode: 'CLIENT_ACTIVATE',
      })
      .then((r) => r.data);
  },

  deactivate(id) {
    return api
      .patch(`/client-minors/${id}/deactivate`, {
        functionCode: 'CLIENT_DEACTIVATE',
      })
      .then((r) => r.data);
  },

  remove(id) {
    return api
      .delete(`/client-minors/${id}`, {
        data: { functionCode: 'CLIENT_MINOR_DELETE' },
      })
      .then((r) => r.data);
  },
};